import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'

import Modal from 'components/modal'
import GridDatesModal from './grid-dates-modal'
import { GRID_DATES_MODAL } from 'constants/modal-constants'
import { hideModal } from 'actions/common'
import { getCurrentModal } from 'selectors/common'
import { getDatePickerDates } from 'selectors/grid'
import { gridDatePickerConfirmDates, gridDatePickerSelectDates } from 'actions/grid'


class GridDatesModalContainer extends Component {

  constructor(props) {
    super(props)

    this.state = {
      range: false,
    }

    this.formatDate = this.formatDate.bind(this)
    this.onContinue = this.onContinue.bind(this)
    this.onDatesChange = this.onDatesChange.bind(this)
    this.onToggleRangeMode = this.onToggleRangeMode.bind(this)
  }

  onDatesChange(dates) {
    this.props.gridDatePickerSelectDates(dates)
  }

  onToggleRangeMode() {
    this.setState({
      range: !this.state.range,
    })
  }

  onContinue() {
    this.props.gridDatePickerConfirmDates()
    this.props.hideModal()
  }

  formatDate(date) {
    return date.format('YYYY-MM-DD')
  }

  render() {
    const isOpen = this.props.currentModal === GRID_DATES_MODAL

    return (
      <Modal light wide closeModal={this.props.hideModal} isOpen={isOpen}>
        <GridDatesModal
          dates={this.props.datePickerDates}
          onDatesChange={this.onDatesChange}
          onToggleRangeMode={this.onToggleRangeMode}
          formatDate={this.formatDate}
          range={this.state.range}
          onContinue={this.onContinue}
        />
      </Modal>
    )
  }
}

GridDatesModalContainer.propTypes = {
  currentModal: PropTypes.string,
  datePickerDates: PropTypes.array.isRequired,
  gridDatePickerConfirmDates: PropTypes.func.isRequired,
  gridDatePickerSelectDates: PropTypes.func.isRequired,
  hideModal: PropTypes.func,
}

const mapStateToProps = state => ({
  currentModal: getCurrentModal(state),
  datePickerDates: getDatePickerDates(state),
})

const mapDispatchToProps = { hideModal, gridDatePickerConfirmDates, gridDatePickerSelectDates }

export default connect(mapStateToProps, mapDispatchToProps)(GridDatesModalContainer)



/** WEBPACK FOOTER **
 ** ./src/components/grid-dates-modal/grid-dates-modal-container.js
 **/